import React from 'react'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'
import { I18n } from '@front/volcanion'

const Header = () => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('company.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('contract.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companyservice.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('status.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('admin.short')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order.short.perso')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order.short.gest')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order.short.company')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order.short.companyuser')} />
  </TableCell>
</>

export default React.memo(Header)
